export { default } from './LazyLoadComponent';
